<template>
  <f7-page name="alaef" @page:init="onPageInit" class="alaef-page">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>A-LAEF</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom v-if="dataLoaded" class="alaef-tb-height">
      <f7-block class="p-0 alaef-toolbar-block">
        <f7-list inline-labels no-hairlines-md class="no-margin-top no-margin-bottom">
          <f7-list-input
              label="Produkt"
              type="select"
              :value="alaef_produkt_selected"
              @change="onProductChange($event)"
          >
            <option v-for="(item, index) in alaef_produkty" :key="'product_'+index" :value="item.value" :title="item.text">{{ item.text }}</option>
          </f7-list-input>
          <f7-list-input
              label="Beh modelu"
              type="select"
              :value="alaef_runtime_selected"
              @change="onRuntimeChange($event)"
          >
            <option v-for="(item, index) in alaef_runtimes" :key="'runtime_'+index" :value="item.value" :title="item.text">{{ item.text }}</option>
          </f7-list-input>
          <f7-list-item>
            <div class="item-title item-label">
              Dĺžka predp.
            </div>
            <div class="item-input-wrap input-dropdown">
            <f7-input
                type="select"
                :value="alaef_range_selected"
                @change="onRangeChange($event)"
            >
              <option v-for="(item, index) in alaef_ranges" :key="'range_'+index" :value="item.value" :title="item.text">{{ item.text }}</option>

            </f7-input>
            </div>
            <div class="item-after">
              <f7-button :disabled="btnPrevDisabled" @click="setPrevRange" icon-f7="arrow_left"></f7-button>
              <f7-button :disabled="btnNextDisabled" @click="setNextRange" icon-f7="arrow_right"></f7-button>
              <!--f7-button :disabled="!dataLoaded" icon-f7="search" @click="toggleZoom"></f7-button-->
            </div>
          </f7-list-item>



        </f7-list>
      </f7-block>
    </f7-toolbar>

    <f7-block class="margin-top-half no-padding align-items-center" style="position:relative" v-if="this.alaef_range_selected !== null">
      <pinch-zoom ref="refZoomAlaef" style="position: relative;" limitPan="true" overflow="visible" disableZoomControl="disable" limitZoom="5" backgroundColor="rgba(255,255,255,1)">
        <img :src="current_image" ref="imgalaef" class="position-relative" @mouseleave="imgMouseLeave" @mousemove="imgMouseMove" @mouseout="imgMouseOut">
        <canvas style="display: none" ref="cs"></canvas>
        <div class="tooltipx-cross" ref="ttipcros"><i class="f7-icons">plus_circle</i></div>
      </pinch-zoom>
      <div class="tooltipx" ref="ttip" :style="ttipStyle">{{ ttipVal }}</div>
    </f7-block>
    <image-preloader
        :srcs="imagesToPreload"
        @loaded-all="imageLoadedAll"
        @loaded="imageLoadedOne"
        @onerror="imagePreloadError"
    />

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import imagePreloader from '../components/imagePreloader'
import _ from 'lodash'

import PinchZoom from 'vue-pinch-zoom';

var progressDialog, loadingDialog;

export default {
  components: {
    'image-preloader': imagePreloader,
    'pinch-zoom': PinchZoom
  },
  data: function () {
    return {
      btnPrevDisabled: true,
      btnNextDisabled: true,
      alaef_data: [],
      dataLoaded: false,
      lastUpdated: 0,

      alaef_produkty: [],
      alaef_produkt_selected: null,

      alaef_runtimes: [],
      alaef_runtime_selected: null,

      alaef_ranges: [],
      alaef_range_selected: null,

      busy: false,
      imagesToPreload: [],
      loaded_images: [],
      current_product: null,
      current_product_meta: {  },
      current_range: null,
      current_files_list: [],
      current_image: SHMUconf.SHMU_CORE_URL + 'img/blank1px.gif',
      isImagesLoading: true,
      step_min: 0,
      step_max: 72,
      step_step: 6,
      counter_max: 100,
      counter_current: 1,
      range_model: null,
      isLoading: false,
      pinchZoomScale: 0,
      showResetZoom: false,
      rzInterval: null,
      isError: false,
      errorMsg: null,
      isFromMouting: true,
      customRangeSelected: null,
      customRunSelected: null,
      ttipStyle: {},
      ttipVal: '',
      imgInCanvas: null,
      canvasData: null,
      showTooltip: true,
      is_debug: false,
      //base_url: 'http://www.shmu.sk/'
      base_url: ''
    };
  },
  destroy() {
    clearInterval(this.rzInterval);
  },
  updated () {
    if (this.alaef_produkty.length > 0) {
      this.alaef_produkty.forEach(v => {

        let alaef_product_name = '?';
        let res = this.alaef_data.meta.find(item => {
          return item.name === v.value;
        })
        if (res) {
          alaef_product_name = res.sk;
        }

        v.text = alaef_product_name;
      });
    }
  },
  watch: {
    showTooltip() {
      this.$ls.set('alaef_tooltip_state', this.showTooltip, 365 * 24 * 60 * 60 * 1000); // 1 rok
    },
    alaef_data() {
      if (this.is_debug) console.log('alaef_data - watch triggered');
      if (this.alaef_data.products.length > 0) {
        this.alaef_produkty = [];

        this.alaef_data.products.forEach(v => {

          let alaef_product_name = '?';
          let res = this.alaef_data.meta.find(item => {
            return item.name === v.name;
          })
          if (res) {
            alaef_product_name = res.sk;
          }

          this.alaef_produkty.push({value:v.name, text:alaef_product_name});
        });

        if (this.alaef_produkty.length > 0) {
          this.alaef_produkt_selected = this.alaef_produkty[0].value;
        }

        this.$nextTick(function() {
          if (this.alaef_runtime_selected !== null && this.alaef_runtimes.length > 0) {
            if (this.is_debug) console.log('alaef_data - setujem novy runtime ');
            this.alaef_runtime_selected = this.alaef_runtimes[0].value;

          }

        });

      }
    },
    alaef_produkt_selected(v) {
      if (this.is_debug) console.log('alaef_produkt_selected', v);
      this.selectProdukt(v);
    },
    alaef_runtime_selected(v) {
      if (this.is_debug) console.log('alaef_runtime_selected', v);
      this.selectRuntime(v);
    },
    alaef_range_selected(v) {
      if (this.is_debug) console.log('alaef_range_selected', v);
      this.selectRange(v);
      if (this.range_model != v) {
        this.range_model = v;
      }
    },
    range_model(v) {
      if (this.alaef_range_selected != v) {
        this.alaef_range_selected = parseInt(v);
      }
      //this.selectRange(parseInt(v));
    },
    pinchZoomScale(v) {
      if (v > 1) {
        this.showResetZoom = true;
      } else {
        this.showResetZoom = false;
      }
    }
  },


  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

    this.rzInterval = setInterval(() => {
      if(this.$refs.refZoomAlaef){
        this.pinchZoomScale = this.$refs.refZoomAlaef.getScale();
      }
    }, 100);

    /*
    if (this.$ls.get('alaef_tooltip_state')) this.showTooltip = true;
    else this.showTooltip = false;

     */


  },
  methods: {
    onPageInit() {
      this.pageReload(null, true)
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 5) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        this.isFromMouting = true;

/*
        let cached_alaef = self.$ls.get('nwp_alaef_v2');
        if (cached_alaef !== null) {
          self.alaef_data = cached_alaef;
          self.dataLoaded = true;
          self.isError = false;
          self.errorMsg = null;
          self.lastUpdated = self.$moment().unix();

        } else {
*/
          self.$f7.dialog.preloader('Načítavam...');

          Axios.get(SHMUconf.API_BASE_URL + 'nwp/getalaefmaps', {
            crossDomain: true,
            cache: false,
          })
              .then((response) => {
                if (!response.data.error) {
                  self.alaef_data = response.data;
                  self.dataLoaded = true;
                  self.isError = false;
                  self.errorMsg = null;
                  // self.$ls.set('nwp_alaef_v2', self.alaef_data, 10 * 60 * 1000); // 10 min
                  self.lastUpdated = self.$moment().unix();
                } else {
                  self.$f7.dialog.alert('Nepodarilo sa načítať údaje pre A-LAEF', 'Nastala chyba');
                  self.isError = true;
                  self.errorMsg = 'Nepodarilo sa načítať údaje pre A-LAEF';

                }
                self.busy = false;
                self.isImagesLoading = false;
                self.$f7.dialog.close();
              }).catch((error) => {
            self.$f7.dialog.close();
            self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
            self.busy = false;
            self.isImagesLoading = false;
            self.isError = true;
            self.errorMsg = 'Nepodarilo sa nadviazať spojenie so serverom SHMÚ';
          });
        }
      // }

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },

    selectProdukt(v) {
      if (v !== null) {
        this.btnPrevDisabled = true;
        this.btnNextDisabled = true;
        this.current_product = null;
        let selected_produkt = this.alaef_data.products.find(item => item.name === v);

        this.current_product_meta = this.alaef_data.meta.find(item => item.name === v);

        let runtimes_avail = [];
        if (selected_produkt) {
          this.current_product = selected_produkt;
          this.customRunSelected = this.alaef_runtime_selected;
          this.customRangeSelected = this.alaef_range_selected;
          // this.alaef_runtime_selected = null;
          // this.alaef_range_selected = null;
          this.alaef_runtimes = [];
          this.alaef_ranges = [];
          selected_produkt.data.forEach(rt => {
            runtimes_avail.push(rt.runtime);
            this.alaef_runtimes.push({
              value: rt.runtime,
              text: this.$moment.unix(rt.runtime).format('DD.MM.YYYY HH') + 'h UTC'
            });
          });

          if (this.alaef_runtimes.length > 0) {
            this.alaef_runtimes.sort((a, b) => (a.value > b.value) ? -1 : ((b.value > a.value) ? 1 : 0));

            if (this.isFromMouting) {
              // ak som zo startu, nastavim prvy
              this.alaef_runtime_selected = this.alaef_runtimes[0].value; // test, ma tu byt 0
            } else {
              // som zo zmeny, tak nastavim povodny, ak existuje
              let run_to_select = this.alaef_runtimes[0].value;
              if (this.customRunSelected !== null && runtimes_avail.indexOf(this.customRunSelected) !== -1) {
                run_to_select = this.customRunSelected;
                if (this.is_debug) console.log('selectProdukt - mam povodny', run_to_select);
              }
              if (this.is_debug) console.log('selectProdukt - run_to_select', run_to_select, this.alaef_runtimes);
              if (this.alaef_runtime_selected === run_to_select) {
                this.selectRuntime(run_to_select)
              } else {
                this.alaef_runtime_selected = run_to_select;
              }
            }
            // this.selectRuntime(this.alaef_runtimes[0].value);
          }
        }
      }
    },
    selectRuntime(v) {
      if (v !== null) {

        if (!this.isFromMouting) {
          this.customRunSelected = v;
        }

        if (this.is_debug) console.log('selectRuntime', v)

        // this.alaef_range_selected = null;
        this.alaef_ranges = [];
        let alaef_ranges_pure = [];
        if (this.current_product) {
          let selected_runtime = this.current_product.data.find(item => parseInt(item.runtime) === parseInt(v));
          if (selected_runtime) {
            this.imagesToPreload = [];
            selected_runtime.files.forEach(fi => {
              alaef_ranges_pure.push(fi.step);
              this.alaef_ranges.push({
                value: fi.step,
                text: fi.step + 'h'
              });
              this.imagesToPreload.push(this.base_url + fi.url);
            });
            if (this.alaef_ranges.length > 0) {
              this.isImagesLoading = true;
              this.busy = true;
              this.current_files_list = selected_runtime.files;

              this.step_min = this.alaef_ranges[0].value;
              this.step_max = this.alaef_ranges[this.alaef_ranges.length-1].value;
              this.step_step = this.alaef_ranges[1].value - this.alaef_ranges[0].value;


              if (this.isFromMouting) {
                if (this.is_debug) console.log('from boot:');
                // zisti hodinu runtime
                let cur_runtime_h = parseInt(this.$moment(this.alaef_runtime_selected*1000).format('H'));
                if (this.is_debug) console.log('runtime UTC hour', cur_runtime_h);

                let cur_hour = parseInt(this.$moment().utc().format('H'));
                if (this.is_debug) console.log('current UTC hour', cur_hour);
                // pripocitaj hodinu runtime k cur_hour
                cur_hour  -= cur_runtime_h;

                if (this.is_debug) console.log('to select', cur_hour);

                let closest =  alaef_ranges_pure.filter(function(v){return v > cur_hour})[0];

                if (this.is_debug) console.log('closest upper found', closest);
                if (this.alaef_range_selected === closest) {
                  if (this.is_debug) console.log('forced select', closest);
                  this.selectRange(closest);
                } else {
                  if (this.is_debug) console.log('trigger to select', closest);
                  this.alaef_range_selected = closest;
                }
                // this.selectRange(closest);

                this.isFromMouting = false;
              } else {
                if (this.is_debug) console.log('from manual select:');
                let range_to_select = this.alaef_ranges[0].value;
                if (this.customRangeSelected !== null && alaef_ranges_pure.indexOf(range_to_select) !== -1) {
                  range_to_select = this.customRangeSelected;
                }
                if (this.is_debug) console.log('first from range: to_select/selected', range_to_select, this.alaef_range_selected);
                if (this.alaef_range_selected === range_to_select) {
                  if (this.is_debug) console.log('forced to select', range_to_select);
                  this.selectRange(range_to_select);
                } else {
                  if (this.is_debug) console.log('trigger to select', range_to_select);
                  this.alaef_range_selected = range_to_select;
                }
                // this.selectRange(range_to_select);
              }

              this.counter_max = this.imagesToPreload.length;
              this.btnNextDisabled = false;

              if (this.imagesToPreload.length > 0) {
                progressDialog = this.$f7.dialog.progress('Načítavam obrázky...', 0);
              }


            }
          } else {
            if (this.is_debug) console.log('runtime v currentproduct.data not found, selected: ', v , ', current_product: ' , this.current_product);
          }
        }
      }
    },
    selectRange(v) {
      if (this.is_debug) console.log('selectRange', v);
      if (v !== null) {
        this.current_range = this.current_files_list.find(item => parseInt(item.step) === parseInt(v));
        this.current_image = this.base_url + this.current_range.url;
        this.updatePrevNextButtons(v);

        if (!this.isFromMouting) {
          this.customRangeSelected = v;
        }
      }



    },
    setNextRange() {
      let cur_step = this.current_range.step;
      let next_step_idx = null;
      let max_idx = this.alaef_ranges.length;
      let current_index = this.alaef_ranges.findIndex(item => parseInt(item.value) === parseInt(cur_step));
      if ((current_index+1) < max_idx) {
        next_step_idx = current_index+1;
      }

      if (next_step_idx !== null) {
        this.alaef_range_selected = this.alaef_ranges[next_step_idx].value;
        // this.selectRange(this.alaef_ranges[next_step_idx].value);
      }

    },
    setPrevRange() {
      let cur_step = this.current_range.step;
      let prev_step_idx = null;
      let current_index = this.alaef_ranges.findIndex(item => parseInt(item.value) === parseInt(cur_step));
      if ((current_index-1) >= 0) {
        prev_step_idx = current_index-1;
      }

      if (prev_step_idx !== null) {
        this.alaef_range_selected = this.alaef_ranges[prev_step_idx].value;
        // this.selectRange(this.alaef_ranges[prev_step_idx].value);
      }

    },
    updatePrevNextButtons(step) {
      let max_idx = this.alaef_ranges.length;
      let current_index = this.alaef_ranges.findIndex(item => parseInt(item.value) === parseInt(step));
      if (current_index === max_idx-1) {
        this.btnNextDisabled = true;
      } else {
        this.btnNextDisabled = false;
      }

      if (current_index === 0) {
        this.btnPrevDisabled = true;
      } else {
        this.btnPrevDisabled = false;
      }

    },
    resetZoom() {
      if (this.$refs.refZoomAlaef.getScale() > 1) {
        this.showResetZoom = false;
        this.$refs.refZoomAlaef.toggleZoom();
      }
    },
    onHidden() {
      // this.$refs.button.focus()
    },
    imageLoadedOne(e) {
      this.counter_current = e.count;
      this.counter_max = e.length;

      progressDialog.setProgress(e.progress);
      progressDialog.setText(e.count + ' z ' + e.length);


    },
    imageLoadedAll(e) {
      this.isImagesLoading = false;
      this.busy = false;
      this.counter_current = 1;
      this.counter_max = 100;
      progressDialog.close();
      progressDialog = null;

    },
    imagePreloadError(e) {
      const self = this;
      this.isImagesLoading = false;
      this.busy = false;
      this.counter_current = 1;
      this.counter_max = 100;
      if (progressDialog !== null) {
        progressDialog.close();
        progressDialog = null;
      }
      self.$f7.dialog.alert('Niektoré obrázky sa nepodarilo načítať.', 'Nastala chyba');
      console.log('Nepodarilo sa nacitat: ',  e.errorImgs);
    },
    //imgMouseMove: _.throttle( function(e) {
    imgMouseMove(e) {

      if (!this.showTooltip) return;

      const self = this;


      if (!self.current_product_meta) return;
      if (!self.current_product_meta.colors) return;
      if (self.current_product_meta.colors.length === 0) return;

      let x, y;
      if(e.offsetX) {
        x = e.offsetX;
        y = e.offsetY;
      }
      else if(e.layerX) {
        x = e.layerX;
        y = e.layerY;
      }
      let canvas = this.$refs['cs'];
      let img = this.$refs['imgalaef'];
      let pz = this.$refs['refZoomAlaef'];

      if (this.imgInCanvas !== this.current_image) {
        if (this.is_debug) console.log('new canvas image')
        this.applyImageToCanvas(canvas, img);
        this.imgInCanvas = this.current_image;
        this.canvasData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
      }

      // let add_x_offset = Math.round((pz.$el.clientWidth - img.clientWidth)/2);
      let add_x_offset = (pz.$el.clientWidth - img.clientWidth)/2;


      // let px = Math.round((x*100)/img.clientWidth);
      // let py = Math.round((y*100)/img.clientHeight);

      let px = (x*100)/img.clientWidth;
      let py = (y*100)/img.clientHeight;


      let nove_x = x+add_x_offset;

      // console.log(pz.$el.clientWidth, img.clientWidth, x, nove_x, y);

      self.$refs['ttip'].style.left = (10)+'px';
      self.$refs['ttip'].style.top = (5)+'px';
      self.$refs['ttip'].style.display = 'block';

      self.$refs['ttipcros'].style.left = ((nove_x)-10)+'px';
      self.$refs['ttipcros'].style.top = (y-10)+'px';
      self.$refs['ttipcros'].style.display = 'block';



      // let p = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
      let index = (y * this.canvasData.width + x) * 4;

      let p = [];
      p.push(this.canvasData.data[index]);
      p.push(this.canvasData.data[index+1]);
      p.push(this.canvasData.data[index+2]);
      p.push(this.canvasData.data[index+3]);

      // show preview color
      if (p) {
        //self.ttipVal = self.rgbToHex(p[0], p[1], p[2]);
        let hex_color = self.rgbToHex(p[0], p[1], p[2]);
        let color_type = 'PRIEMER';
        if (self.current_product_meta.color_type === 'all') color_type = 'ALL';
        else {
          if (px >= 50 && py <= 50) color_type = 'ROZPTYL';
          else color_type = 'PRIEMER';
        }

        //console.log(color_type)

        let skala = self.current_product_meta.colors.filter( item => item.type === color_type);

        let naslo_sa = skala.find(item => this.isNeighborColor(this.hexToRgb(item.hex_color), this.hexToRgb(hex_color), 3));

        if (naslo_sa) {
          // self.$refs['ttip'].innerHTML = naslo_sa.display + ' ' + hex_color;
          self.$refs['ttip'].innerHTML = naslo_sa.display;
          self.$refs['ttip'].style.display = 'block';
          self.$refs['ttipcros'].style.display = 'block';
        } else {
          // self.$refs['ttip'].style.display = 'block';
          // self.$refs['ttip'].innerHTML = hex_color;
          self.$refs['ttip'].style.display = 'none';
          self.$refs['ttipcros'].style.display = 'none';
        }


      }

    //}, 150),
    },
    imgMouseLeave: _.debounce( function() {
      // console.log('heh')
      this.$refs['ttip'].style.display = 'none';
      this.$refs['ttipcros'].style.display = 'none';

    },2000),
    imgMouseOut(e) {

    },
    applyImageToCanvas(el, image)  {
      el.width = image.width; // img width
      el.height = image.height; // img height
      // draw image in canvas tag
      el.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
    },
    componentToHex(c) {
      if (c) {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      }
      return "00";
    },
    rgbToHex(r, g, b) {
      return this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },
    hexToRgb(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    isNeighborColor(color1, color2, tolerance) {
      if (tolerance === undefined) {
        tolerance = 10;
      }

      // console.log(color1, color2);

      return Math.abs(color1.r - color2.r) <= tolerance
          && Math.abs(color1.g - color2.g) <= tolerance
          && Math.abs(color1.b - color2.b) <= tolerance;
    },

    onProductChange(e) {
      this.alaef_produkt_selected = e.target.value;
    },
    onRuntimeChange(e) {
      this.alaef_runtime_selected = e.target.value;
    },
    onRangeChange(e) {
      this.alaef_range_selected = e.target.value;
    },
    toggleZoom() {
      this.$refs['refZoomAlaef'].toggleZoom();
    },


  }

};
</script>

<style lang="scss">

.alaef-toolbar-block {
  margin: 0px auto;
  width: 350px;
  .list {
    ul {
      background-color: var(--f7-toolbar-bg-color, var(--f7-bars-bg-color)) !important;
    }
  }
}

.alaef-tb-height {
  height:173px;
}

.tooltipx {
  position: absolute;
  background-color: rgba(0,0,0,0.7);
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 3px;
  top: -500px;
  left: -500px;
  text-align: center;
  z-index: 100;
  width: 55px;
  height: 23px;
  line-height: 18px;
  font-size:0.8rem;
  display: none;
}

.tooltipx-cross {
  position: absolute;
  color: black;
  border: none;
  top: -500px;
  left: -500px;
  text-align: center;
  z-index: 100;
  width: 20px;
  height: 20px;
  font-size:1rem;
  display: none;
  cursor: crosshair;
  i {
    cursor: crosshair;
    font-size: 16px;
  }
}

.alaef-card {
  font-size:0.9em;

  .custom-select {
    font-size: 1em;
  }

}

.alaef-page {
  .page-content {
    padding-bottom: 173px;
  }
}

</style>
